import paramsUtils from '@lib/params'
import url from '@lib/url'
import { ParamsStore } from '@stores/params'

export default (params: ParamsStore): string => {
  const parameters = paramsUtils.getPersistentUrlParams(params)

  return url.build([location.origin], parameters)
}
